import { createFileRoute, useSearch } from "@tanstack/react-router";
import { dehydrate, DehydratedState, hydrate, useQuery, useQueryClient } from "@tanstack/react-query";
import { businessQueryOptions } from "@/server/business-directory";
import { BusinessOrganisationsForm } from "../../-components/business-organisations-form";
import { BusinessReadable } from "@/lib/mma";
import { useEffect } from "react";
import { ContextUser } from "@/lib/utils";

export const Route = createFileRoute("/_dashboard/business-directory/businesses/organisations")({
  component: RouteComponent,
  validateSearch: (search: Record<string, unknown>) => {
    const id = search.id !== undefined ? Number(search.id) : undefined;
    return { id };
  },
  loaderDeps: ({ search }) => {
    return { id: search.id };
  },
  loader: async ({ context, deps }) => {
    const { id } = deps;
    const user = context.user as ContextUser | null | undefined;
    if (id) {
      try {
        const queryOptions = businessQueryOptions(id as number);
        await context.queryClient.prefetchQuery(queryOptions);
        const dehydratedState = dehydrate(context.queryClient) as any;
        return {
          crumb: "Organisations",
          dehydratedState,
          user,
        };
      } catch (error) {
        return {
          crumb: "Organisations",
          dehydratedState: dehydrate(context.queryClient) as any,
          user,
        };
      }
    }
    return { crumb: "Organisations", user };
  },
});

function RouteComponent() {
  const { dehydratedState, user } = Route.useLoaderData() as {
    dehydratedState: DehydratedState;
    user: ContextUser | null | undefined;
  };
  const queryClient = useQueryClient();
  hydrate(queryClient, dehydratedState);
  const search = useSearch({ from: "/_dashboard/business-directory/businesses/organisations" });

  const businessQuery = useQuery(businessQueryOptions(typeof search.id === "number" ? search.id : 0));
  const business = businessQuery.data;

  useEffect(() => {
    if (!search.id) return;
    void businessQuery.refetch();
  }, [search.id, businessQuery.refetch]);

  return <BusinessOrganisationsForm business={business as BusinessReadable} user={user} />;
}
